import script from "./StoryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryTab.vue?vue&type=script&setup=true&lang=js"

import "./StoryTab.vue?vue&type=style&index=0&id=1dac140b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dac140b"]])

export default __exports__